import { render, staticRenderFns } from "./VipRewardType.vue?vue&type=template&id=1cb96f47&lang=pug"
import script from "./VipRewardType.vue?vue&type=script&lang=js"
export * from "./VipRewardType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports